module.exports = __webpack_public_path__ + "static/media/Our_mission.be8a5530.jpg";